import axios from 'axios'

export const getChallenge = async (config: any) => {
  const configData = JSON.parse(JSON.stringify(config.data))
  config.headers['X-Challenge-Request'] = config.uid
  config.headers['X-Challenge-Payload'] = config.uid
  delete config.data
  const response: { headers: object } = await axios(config)
  delete config.headers['X-Challenge-Request']
  config.data = configData
  return response.headers['x-challenge-request']
}
